/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-07-31 10:30:08
 */

import * as request from '@/utils/request'

export default {
  /**
   * getJobList
   * @description 批次任务列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getJobList(data) {
    return request.post('/task/daily_list', data)
  },
  /**
   * saveJob
   * @description 保存批次任务
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveJob(data) {
    return request.post('/task/store', data)
  },
  getTaxbasisJob(data) {
    return request.post('/task/check_tax_fee', data)
  },
  /**
   * getJobInfo
   * @description 获取公司详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  // getJobInfo(id) {
  //   let data = {id:id}
  //   return request.post('/task/get_info', data)
  // },
    getJobInfo(data) {
      return request.post('/task/get_daily_info', data)
    },
  /**
   * deleteJob
   * @description 删除批次任务
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteJob(id) {
    let data = {id:id}
    return request.post('/task/delete', data)
  },
  /**
   * saveJob
   * @description 提交批次任务
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  sendJob(data) {
    return request.post('/task/daily_send', data)
  },
  /**
   * cancelJob
   * @description 作废批次任务
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  cancelJob(data) {
    return request.post('/task/change_status', data)
  },
  /**
   * @description 获取分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getJobCategoryList() {
    return request.post('/task/category_list')
  },
  /**
   * getJobSign
   * @description 获取签约情况
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getJobSign(data) {
    return  request.post('/customer/check_sign', data)
  },
  getJobSigns(data) {
    return  request.post('/customer/check_signs', data)
  },
  // 银行卡是否认证
  getCardIsAuth(data) {
    return  request.post('/customer/check_cards', data)
  },
  // 计算劳务费
  postCheckLaborFee(data){
    return request.post('/task/check_labor_fee',data)
  },
  // 岗位报名列表
  postDaily_postjoin_list(data){
    return request.post('/daily_post/join_list',data)
  },
  // 报名审核
  postDaily_postAudit(data){
    return request.post('/daily_post/audit',data)
  }
}